// AUTO-GENERATED — do not edit manually.
// Source of truth: package.json "version" field.
export const VERSION = "1.5.0";
